import { render, staticRenderFns } from "./SelectDic.vue?vue&type=template&id=569d2f0c&"
import script from "./SelectDic.vue?vue&type=script&lang=js&"
export * from "./SelectDic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports